/**
 * Created by chenzheyu on 2017/6/19.
 */
import XKcarType from './src/carType.vue'

XKcarType.install = function (Vue) {
  Vue.component(XKcarType.name, XKcarType)
}

export default XKcarType



// WEBPACK FOOTER //
// ./src/components/module/carType/index.js